import { useState, useRef, useEffect } from "react";
function useBlobLevel(state) {
  const [level, setLevel] = useState(0);
  const target = useRef(0);
  const raf = useRef(null);
  const t = useRef(0);
  useEffect(() => {
    const tick = () => {
      t.current += 1;
      const T = t.current;
      let next = 0;
      let smoothing = 0.18;
      switch (state) {
        case "idle":
        case "muted":
        case "ended":
          next = 0.02 + 0.02 * Math.sin(T * 0.03);
          smoothing = 0.08;
          break;
        case "connecting": {
          next = 0.08 + 0.06 * Math.sin(T * 0.03);
          smoothing = 0.06;
          break;
        }
        case "listening": {
          const base = 0.45 + 0.25 * Math.sin(T * 0.06) + 0.15 * Math.sin(T * 0.17 + 1.3) + 0.1 * Math.sin(T * 0.31 + 2.4);
          const noise = (Math.random() - 0.5) * 0.25;
          next = Math.max(0.08, Math.min(1, base + noise));
          smoothing = 0.25;
          break;
        }
        case "thinking": {
          next = 0.3 + 0.22 * Math.sin(T * 0.035);
          smoothing = 0.06;
          break;
        }
        case "tool": {
          const pulse = 0.5 + 0.18 * Math.sin(T * 0.12);
          const tick2 = Math.sin(T * 0.5) > 0.92 ? 0.08 : 0;
          next = pulse + tick2;
          smoothing = 0.18;
          break;
        }
        case "error": {
          next = 0.4 + 0.25 * Math.sin(T * 0.05);
          smoothing = 0.1;
          break;
        }
        default:
          next = 0;
      }
      target.current = next;
      setLevel((l) => l + (target.current - l) * smoothing);
      raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => {
      if (raf.current != null) cancelAnimationFrame(raf.current);
    };
  }, [state]);
  return level;
}
export {
  useBlobLevel
};
//# sourceMappingURL=useBlobLevel.js.map
